import type { ResourcesConfig } from 'aws-amplify'

/**
 * AWS Amplify v6 configuration for Customer App
 *
 * Uses separate Cognito User Pool from consultant app
 */
export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_AWS_COGNITO_CLIENT_ID || '',
      identityPoolId: import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_AWS_COGNITO_DOMAIN || '',
          scopes: (import.meta.env.VITE_OAUTH_SCOPES || 'openid,email,profile').split(',') as (
            | 'openid'
            | 'email'
            | 'profile'
            | 'phone'
            | 'aws.cognito.signin.user.admin'
          )[],
          redirectSignIn: (import.meta.env.VITE_OAUTH_REDIRECT_SIGN_IN || '').split(','),
          redirectSignOut: (import.meta.env.VITE_OAUTH_REDIRECT_SIGN_OUT || '').split(','),
          responseType: 'code',
          providers: ['Google', 'Facebook', 'Apple'],
        },
        email: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
}

export default amplifyConfig
